document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName("service_agreement_form");
  if (pages.length == 0) return;

  const urlInput = document.querySelector(".opt .url");
  const messageInput = document.querySelector(".opt .rich-message");
  const hiddenMessageInput = document.querySelector(".editor-field input");

  const enableUrlType = () => {
    urlInput.disabled = false;
    messageInput.contentEditable = false;
    hiddenMessageInput.disabled = true;
  };

  const enableMessageType = () => {
    urlInput.disabled = true;
    messageInput.contentEditable = true;
    hiddenMessageInput.disabled = false;
  };

  const checkedRadio = document.querySelector(".hidden-radio:checked");
  if (!checkedRadio) {
    urlInput.disabled = true;
    messageInput.contentEditable = false;
  } else if (checkedRadio.id == "url_type") {
    enableUrlType();
  } else if (checkedRadio.id == "message_type") {
    enableMessageType();
  }

  const optUrlButton = document.getElementById("opt-url");
  const optMessageButton = document.getElementById("opt-message");
  optUrlButton.addEventListener("change", () => {
    enableUrlType();
  });
  optMessageButton.addEventListener("change", () => {
    enableMessageType();
  });
});
